import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Power } from "lucide-react";
import { api, errMsg } from "@/lib/api";

// Master switch: while ON the server keeps today's Kite live run going 09:10–15:15 on weekdays
export function EngineSwitch() {
  const [e, setE] = useState(null);
  useEffect(() => {
    const load = () => api.get("/engine").then((r) => setE(r.data)).catch(() => {});
    load();
    const i = setInterval(load, 5000);
    return () => clearInterval(i);
  }, []);
  const put = async (on, mode) => {
    if (on && mode === "trade" && !window.confirm("Engine ON in TRADE mode: on every market day it will start at 09:10 and place REAL orders at Zerodha without you pressing Start. Continue?")) return;
    try { setE((await api.put("/engine", { on, mode })).data); toast.success(`Engine ${on ? "ON" : "OFF"}`); } catch (x) { toast.error(errMsg(x)); }
  };
  if (!e) return null;
  return (
    <div className={`panel p-3 flex flex-wrap items-center gap-3 ${e.on ? "border-emerald-500/50" : ""}`} data-testid="engine-panel">
      <button onClick={() => put(!e.on, e.mode)} aria-pressed={e.on} data-testid="engine-switch"
        className={`h-10 px-4 rounded-md border flex items-center gap-2 text-sm font-semibold transition-colors ${e.on ? "border-emerald-500/60 bg-emerald-500/15 text-emerald-300" : "border-slate-600 bg-[#0B111D] text-slate-400 hover:text-slate-200"}`}>
        <Power size={15} />Engine {e.on ? "ON" : "OFF"}
        <span className={`w-8 h-4 rounded-full relative ${e.on ? "bg-emerald-500" : "bg-slate-600"}`}>
          <span className={`absolute left-0 top-0.5 w-3 h-3 rounded-full bg-white transition-transform ${e.on ? "translate-x-4" : "translate-x-0.5"}`} />
        </span>
      </button>
      <div className="flex rounded-md border border-[#1E293B] overflow-hidden text-xs" data-testid="engine-mode">
        {["paper", "trade"].map((m) => (
          <button key={m} onClick={() => (e.on ? put(true, m) : setE({ ...e, mode: m }))} data-testid={`engine-mode-${m}`}
            className={`px-3 h-10 font-medium ${e.mode === m ? (m === "trade" ? "bg-red-500/20 text-red-300" : "bg-[#1A2235] text-cyan-300") : "text-slate-400 hover:text-slate-100"}`}>
            {m === "trade" ? "Trade (real)" : "Paper"}
          </button>
        ))}
      </div>
      <div className="text-xs min-w-0 flex-1">
        <div className="text-slate-300 truncate" data-testid="engine-status">{e.on ? e.status || "Checking…" : "Engine OFF — runs only start when you press Start"}</div>
        <div className="text-[10px] text-slate-500">Keeps the Kite live run going on weekdays 09:10–15:15 — starts it, and starts it again if it stops unexpectedly{e.on && e.checked ? ` · checked ${e.checked}` : ""}</div>
      </div>
    </div>
  );
}
